// Progressive enhancement. The page is fully readable without JS; this wires the
// samples form to a real endpoint, handles errors, and persists a draft across refreshes.
(function () {
  var form = document.getElementById('samples-form');
  var success = document.querySelector('.form__success');
  var errorBox = document.getElementById('form-error');
  var STORE = 'bighorn-samples-draft';

  // The endpoint is the form's action (a Formspree URL). If it is missing or
  // still '#', the form runs in demo mode: it validates and shows success
  // without sending anything.
  var action = form ? form.getAttribute('action') : '';
  var FORM_ENDPOINT = (action && action !== '#') ? action : '';

  if (form && success) {
    var btn = form.querySelector('button[type="submit"]');

    // Restore an in-progress draft so an interruption or refresh does not lose typing.
    try {
      var saved = JSON.parse(localStorage.getItem(STORE) || '{}');
      Object.keys(saved).forEach(function (k) {
        if (form.elements[k] && !form.elements[k].value) form.elements[k].value = saved[k];
      });
    } catch (e) {}
    form.addEventListener('input', function () {
      try {
        var data = {};
        Array.prototype.forEach.call(form.elements, function (el) {
          if (el.name && el.type !== 'submit') data[el.name] = el.value;
        });
        localStorage.setItem(STORE, JSON.stringify(data));
      } catch (e) {}
    });

    function succeed() {
      try { localStorage.removeItem(STORE); } catch (e) {}
      form.hidden = true;
      success.hidden = false;
      success.focus();
    }
    function fail() {
      btn.disabled = false;
      btn.textContent = form.dataset.submitLabel || 'Reserve my samples';
      if (errorBox) {
        errorBox.textContent = form.dataset.errorMessage || '';
        errorBox.hidden = false;
      }
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (errorBox) errorBox.hidden = true;
      if (!form.reportValidity()) return;   // native inline messages, focuses first invalid field
      btn.disabled = true;
      btn.textContent = form.dataset.submittingLabel || 'Reserving';
      if (!FORM_ENDPOINT) { succeed(); return; }   // demo mode until the endpoint is set
      fetch(FORM_ENDPOINT, {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) { r.ok ? succeed() : fail(); })
        .catch(fail);
    });
  }

  var pre = document.getElementById('preorder-btn');
  if (pre) {
    pre.addEventListener('click', function (e) {
      if (pre.getAttribute('href') === '#') {
        e.preventDefault();
        if (!document.getElementById('preorder-pending')) {
          pre.insertAdjacentHTML('afterend',
            '<p class="fineprint muted" id="preorder-pending" role="status">' + (pre.dataset.pendingMessage || '') + '</p>');
        }
      }
    });
  }
})();
